import { toggleItems } from "app/components/widget/widget-utilities/time-granularity";
import dayjs from "dayjs";
import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import noLegendConfig from "pro-features/components/Chart/src/configs/legend/noLegendConfig";
import xAxisCrosshair from "pro-features/components/Chart/src/configs/xAxis/xAxisCrosshair";
import xAxisLabelsConfig from "pro-features/components/Chart/src/configs/xAxis/xAxisLabelsConfig";
import yAxisLabelsConfig from "pro-features/components/Chart/src/configs/yAxis/yAxisLabelsConfig";
import tooltipContainerConfig from "pro-features/components/Chart/src/configs/tooltip/tooltipContainerConfig";
import ReactDOMServer from "react-dom/server";
import { colorsPalettes } from "@similarweb/styles";
import monthlyIntervalConfig from "pro-features/components/Chart/src/configs/granularity/monthlyIntervalConfig";
import { percentageSignFilter } from "app/filters/ngFilters";
import { Tooltip } from "app/pages/website-analysis/audience-interests/single/CrossBrowsingOvertime/Tooltip";

export const getChartConfig = (params) => {
    const xAxisFormatter = ({ value }) => dayjs.utc(value).format(toggleItems.Monthly.format);
    const yAxisFormatter = ({ value }) => percentageSignFilter()(value, 2);
    const chartConfig = combineConfigs({ xAxisFormatter, yAxisFormatter }, [
        noLegendConfig,
        xAxisCrosshair,
        xAxisLabelsConfig,
        yAxisLabelsConfig,
        tooltipContainerConfig,
        monthlyIntervalConfig,
        {
            tooltip: {
                followPointer: false,
                shared: true,
                outside: true,
                useHTML: true,
                formatter: function () {
                    return ReactDOMServer.renderToString(
                        <Tooltip
                            points={this.points}
                            params={params}
                        />,
                    );
                },
            },
            chart: {
                height: 220,
                spacingTop: 10,
                plotBackgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "Roboto",
                },
            },
            plotOptions: {
                line: {
                    lineWidth: 2,
                    connectNulls: false,
                },
                area: {
                    stacking: "normal",
                },
                series: {
                    turboThreshold: 5000,
                    fillOpacity: 1,
                    marker: {
                        enabled: true,
                        symbol: "circle",
                    },
                    stacking: false,
                    animation: false,
                },
            },
            yAxis: {
                gridLineWidth: 0.5,
                showFirstLabel: true,
                showLastLabel: true,
                reversed: false,
                gridZIndex: 2,
                reversedStacks: true,
                tickPixelInterval: 50,
                labels: {
                    style: {
                        textTransform: "uppercase",
                        fontSize: "11px",
                        fontFamily: "Roboto",
                        color: colorsPalettes.carbon[200],
                    },
                },
            },
            xAxis: {
                gridLineWidth: 0,
                gridLineDashStyle: "dash",
                tickLength: 5,
                labels: {
                    style: {
                        textTransform: "capitalize",
                        fontSize: "11px",
                        color: "#919191",
                        fontFamily: "Roboto",
                    },
                },
                minPadding: 0,
                maxPadding: 0,
            },
        },
    ]);
    return chartConfig;
};
